import { Modal } from "antd";
import { useState } from "react";
import "./index.less";
const prefix = "login-alert-modal";

function LoginAlertModal({ onClose, onOk }: any) {
  const handleOk = async (data: any) => {
    try {
      onOk();
    } catch (errorInfo: any) {
      console.error(errorInfo);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      title={"温馨提示"}
      centered
      open={true}
      width={520}
      destroyOnClose
      confirmLoading={false}
      cancelText={"取消"}
      okText={"登录"}
      onCancel={handleCancel}
      onOk={handleOk}
      maskClosable={false}
      className={`${prefix}-modal`}
    >
      <span style={{ display: "block", marginTop: "24px" }}>请登录后查看完整内容</span>
    </Modal>
  );
}

export default LoginAlertModal;
